import { isFeatureEnabled } from '#src/lib/experimentation';
import { getEnvironment } from '#src/lib/utils.mjs';

const STORE_NAME = 'WayBetter, Inc.';

function googlePayOptions(totalPrice) {
  const { GOOGLE_PAY_MERCHANT_ID } = getEnvironment();
  return (
    GOOGLE_PAY_MERCHANT_ID && {
      googlePay: {
        merchantId: GOOGLE_PAY_MERCHANT_ID,
        transactionInfo: {
          currencyCode: 'USD',
          totalPriceStatus: 'FINAL',
          totalPrice,
        },
      },
    }
  );
}

const paypalOptions = (amount) => {
  return {
    paypal: {
      flow: 'vault',
      amount,
      currency: 'USD',
      buttonStyle: {
        size: 'responsive',
        color: 'gold',
        shape: 'pill',
        label: 'checkout',
      },
      commit: true,
    },
  };
};

const applePayOptions = (amount) => {
  return {
    applePay: {
      displayName: STORE_NAME,
      paymentRequest: {
        total: {
          label: STORE_NAME,
          amount,
        },
      },
    },
  };
};

export const buildBraintreeOptions = ({ authorization, amount, _show }) => {
  const options = {
    authorization,
    card: {
      cardholderName: false,
    },
    ...paypalOptions(amount),
    ...applePayOptions(amount),
    ...googlePayOptions(amount),
  };

  if (isFeatureEnabled('EXP_WBRT_2737_HUB_REMOVE_APPLE_GOOGLE_PAY')) {
    delete options.applePay;
    delete options.googlePay;
  }

  if (isFeatureEnabled('EXP_WBRT_4995_HUB_REMOVE_PAYPAL')) {
    delete options.paypal;
  }

  return options;
};
